// removed by extract-text-webpack-plugin
module.exports = {"button":"_1jdkYwPWFGMhaWzHQe9VTs","noBottomMargin":"_2pIdEVHFTvkFrH4by72yYS"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/TextApplyFrontend/style.scss
// module id = 2535
// module chunks = 1